import { useSyncExternalStore } from "react";

// Entrega consultada pelo cliente (cidade/CEP e frete escolhido). Vai junto em todas as mensagens do WhatsApp.
const KEY = "rc_delivery";
const listeners = new Set();
const brl = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

const read = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    return v && typeof v === "object" ? v : {};
  } catch {
    return {};
  }
};

let snapshot = read();
const save = (next) => {
  snapshot = next;
  localStorage.setItem(KEY, JSON.stringify(snapshot));
  listeners.forEach((l) => l());
};

const subscribe = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const getDelivery = () => snapshot;
export const useDelivery = () => useSyncExternalStore(subscribe, () => snapshot);

// Nova consulta de cidade/CEP: troca a cidade e esquece o frete escolhido se a cidade mudou.
export const setDeliveryCheck = (check, cep = "") => {
  const same = snapshot.check?.city?.id === check?.city?.id;
  save({ check, cep: cep || (same ? snapshot.cep : ""), freight: same ? snapshot.freight : null });
};
export const setFreightChoice = (freight) => save({ ...snapshot, freight });

// Itens cotados (para saber se o frete escolhido vale para o carrinho atual).
export const scopeOf = (items) => JSON.stringify(items);

// Entrega do carrinho: grátis dentro do raio, ou o frete escolhido para exatamente estes itens. null = ainda sem frete.
export const cartShipping = (d, scope) => {
  if (d?.check?.available) return { label: "Entrega grátis", amount: 0 };
  const f = d?.freight;
  if (f?.price && f.scope === scope) return { label: `Frete ${f.service} ${f.insured ? "com" : "sem"} seguro`, amount: f.price };
  return null;
};

const fmtCep = (c) => (c?.length === 8 ? `${c.slice(0, 5)}-${c.slice(5)}` : c);

export const deliveryLine = (d = snapshot) => {
  const c = d?.check;
  if (!c?.city) return "";
  const place = `${c.city.name} - ${c.city.uf}${d.cep ? ` (CEP ${fmtCep(d.cep)})` : ""}`;
  if (c.available) return `*Entrega:* ${place} · entrega grátis (${c.distance_km} km da loja)`;
  const f = d.freight;
  if (f?.price) return `*Entrega:* ${place} · frete ${f.service} ${f.insured ? "com seguro" : "sem seguro"} ${brl.format(f.price)}${f.days ? ` (${f.days} dias úteis)` : ""}`;
  return `*Entrega:* ${place} · fora da entrega grátis, quero combinar o envio`;
};
